export const Layout = {
  SIDE_IMAGE: require("assets/boy-with-rocket-light.png"),
  LOGO: require("assets/logo.png"),
  AVATAR: require("assets/avatar.png"),
};
